import { FC } from 'react';

import { SPACING } from '~/common/layout-propertis/spacing';
import { Typography } from '~/common/components/Typography';
import { Modal } from '~/common/components/Modal';

import { StyContainer, StyContent } from '../styles';

interface ITermsModal {
  open: boolean;
  close: () => void;
}

export const TermsModal: FC<ITermsModal> = ({ open, close }) => {
  return (
    <Modal
      id="termos-uso-modal"
      isOpen={open}
      onClose={close}
      height="600px"
      width="700px"
      justifyContent="start"
      title="Termos de Uso"
      closeOnOutsideClick
    >
      <StyContainer>
        <StyContent>
          <Typography.Label size="medium">1. Introdução</Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            Seja bem-vindo ao CryptoControl. Ao utilizar nosso sistema, você
            está concordando com os Termos de Uso abaixo. Por favor, leia
            atentamente para entender suas responsabilidades e os nossos
            compromissos.
          </Typography.Label>
        </StyContent>
        <StyContent>
          <Typography.Label size="medium">
            2. Aceitação dos Termos
          </Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            Ao acessar e utilizar nosso sistema, você concorda integralmente com
            estes Termos de Uso. Caso não concorde, recomendamos não utilizar
            nossos serviços.
          </Typography.Label>
        </StyContent>
        <StyContent>
          <Typography.Label size="medium">3. Uso do Sistema</Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            O CryptoControl é uma ferramenta de organização, visualização e
            análise de dados públicos e históricos do mercado de criptomoedas. O
            sistema oferece funcionalidades como:
          </Typography.Label>
        </StyContent>
        <StyContent>
          <Typography.Label size="small" color="neutral.400">
            Acompanhamento de portfólio;
          </Typography.Label>
        </StyContent>
        <StyContent>
          <Typography.Label size="small" color="neutral.400">
            Indicadores gráficos técnicos;
          </Typography.Label>
        </StyContent>
        <StyContent>
          <Typography.Label size="small" color="neutral.400">
            Alertas automatizados baseados em critérios objetivos;
          </Typography.Label>
        </StyContent>
        <StyContent>
          <Typography.Label size="small" color="neutral.400">
            Consolidação de informações públicas de mercado.
            <br />
            <Typography.Label size="small" color="neutral.400">
              O sistema não fornece qualquer forma de recomendação de compra,
              venda, manutenção ou qualquer outra estratégia de investimento.{' '}
            </Typography.Label>
          </Typography.Label>
        </StyContent>
        <StyContent>
          <Typography.Label size="medium">
            4. Caráter Informativo e Educacional
          </Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            Todas as informações, análises e funcionalidades do sistema são
            oferecidas com finalidade estritamente educacional, informativa e
            ilustrativa. O conteúdo disponibilizado não deve ser interpretado
            como orientação profissional, sugestão de operação ou análise
            personalizada.
          </Typography.Label>
        </StyContent>
        <StyContent>
          <Typography.Label size="medium">
            5. Ausência de Consultoria Financeira ou Certificação Profissional
          </Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            O CryptoControl não realiza consultoria de valores mobiliários,
            análise técnica profissional ou assessoria de investimentos, nos
            termos da Instrução CVM 592 e demais normas aplicáveis. Não há
            atuação como analista ou consultor registrado junto à CVM ou
            associação autorizada como a ANBIMA. O usuário é responsável por
            suas próprias decisões e por buscar orientação qualificada quando
            necessário.
          </Typography.Label>
        </StyContent>
        <StyContent>
          <Typography.Label size="medium">
            6. Responsabilidade do Usuário
          </Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            As decisões tomadas com base nas funcionalidades ou dados fornecidos
            pelo CryptoControl são de inteira responsabilidade do usuário. Não
            nos responsabilizamos por prejuízos, perdas financeiras ou decisões
            equivocadas.
          </Typography.Label>
        </StyContent>
        <StyContent>
          <Typography.Label size="medium">
            7. Limitação de Responsabilidade
          </Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            Embora busquemos sempre a exatidão das informações, não garantimos
            ausência de erros, atrasos ou omissões. A utilização dos dados e
            funcionalidades se dá por conta e risco do usuário.
          </Typography.Label>
        </StyContent>
        <StyContent>
          <Typography.Label size="medium">
            8. Manutenção e Atualizações
          </Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            Podemos realizar ajustes técnicos, atualizações e manutenções
            periódicas sem aviso prévio. Tais atualizações podem alterar ou
            descontinuar funcionalidades.
          </Typography.Label>
        </StyContent>
        <StyContent>
          <Typography.Label size="medium">
            9. Alterações nos Termos
          </Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            Reservamo-nos o direito de alterar estes Termos de Uso a qualquer
            momento. A continuação do uso do sistema após a publicação das
            alterações será interpretada como aceitação integral.
          </Typography.Label>
        </StyContent>
        <StyContent>
          <Typography.Label size="medium">
            10. Rescisão de Acesso
          </Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            O descumprimento dos Termos de Uso pode implicar na suspensão ou
            encerramento imediato do acesso ao sistema, a nosso critério.
          </Typography.Label>
        </StyContent>
        <StyContent>
          <Typography.Label size="medium">
            11. Propriedade Intelectual
          </Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            Todo o conteúdo, código e identidade visual do sistema são
            protegidos por direitos autorais e não podem ser copiados,
            distribuídos ou utilizados sem autorização.
          </Typography.Label>
        </StyContent>
        <StyContent>
          <Typography.Label size="medium">
            12. Jurisdição e Lei Aplicável
          </Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            Estes Termos são regidos pelas leis da República Federativa do
            Brasil. Eventuais disputas serão tratadas no foro da comarca de São
            Paulo/SP.
          </Typography.Label>
        </StyContent>
        <StyContent>
          <Typography.Label size="medium">
            13. Assinatura, Cancelamento e Reembolso
          </Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            Ao assinar, o usuário terá acesso ao serviço conforme o período
            contratado, 30 dias corridos no plano mensal ou 12 meses (365 dias)
            no plano anual.
          </Typography.Label>

          <Typography.Label size="small" color="neutral.400">
            Cancelamentos não geram reembolso proporcional. A primeira
            assinatura conta com 7 dias gratuitos no plano Platinum; caso o
            cancelamento não seja realizado dentro desse período, a cobrança
            será feita automaticamente conforme o plano escolhido.
          </Typography.Label>

          <Typography.Label size="small" color="neutral.400">
            No caso do plano anual, o usuário assume um compromisso de 12 meses
            de vigência. Por se tratar de um plano com preço reduzido em relação
            ao mensal, o cancelamento após os 7 dias de carência só poderá
            ocorrer ao final do período contratado (365 dias), sem possibilidade
            de cancelamento antecipado ou reembolso parcial.
          </Typography.Label>

          <Typography.Label size="small" color="neutral.400">
            <b>Importante:</b> o usuário pode cancelar o plano anual dentro dos
            7 dias iniciais, período que garante o direito de arrependimento e
            evita qualquer cobrança.
          </Typography.Label>
        </StyContent>
        <StyContent>
          <Typography.Label size="medium">
            14. Cancelamento e Gestão da Assinatura
          </Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            {`O cancelamento pode ser feito a qualquer momento, via Configurações > Cancelar Assinatura (Canto inferior direito). Cancelamentos após a cobrança não geram reembolso proporcional.`}
          </Typography.Label>
        </StyContent>
        <StyContent>
          <Typography.Label size="medium">
            15. Declaração Final
          </Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            O uso do CryptoControl implica no reconhecimento de que o sistema
            não se propõe a substituir profissionais certificados, não realiza
            recomendações de investimentos e não se configura como serviço
            regulado pela CVM, ANBIMA ou entidades semelhantes.
          </Typography.Label>
        </StyContent>
        <StyContent>
          <Typography.Label size="medium">
            16. Web3 - Carteira, Caixinha e Swap
          </Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            Taxas e Encargos. Os serviços poderão estar sujeitos à cobrança de
            taxas, dependendo do tipo de transação ou produto utilizado.
          </Typography.Label>

          <Typography.Label size="small" color="neutral.400">
            Para investimentos realizados por meio das estratégias da
            “Caixinha”, será aplicada uma taxa de performance de 5% sobre o
            desempenho positivo gerado pela estratégia, calculada e cobrada de
            forma recorrente mensalmente.
          </Typography.Label>

          <Typography.Label size="small" color="neutral.400">
            Para transações de Swap realizadas por meio do CryptoControl, será
            aplicada uma taxa fixa de 50 pontos-base (0,50%) por transação.
            Adicionalmente, o provedor de bridge e/ou swap aplicável poderá
            cobrar uma taxa adicional, dependendo da rota selecionada,
            geralmente variando entre 1 ponto-base (0,01%) para rotas de USDC
            para USDC e até 100 pontos-base (1,00%) para rotas mais exóticas.
            Essas taxas de terceiros são independentes da taxa cobrada pelo
            CryptoControl e poderão variar de acordo com o provedor e a rota
            da transação.
          </Typography.Label>

          <Typography.Label size="small" color="neutral.400">
            Para transações de Ramp, envolvendo a conversão de moeda
            fiduciária (fiat) em criptoativos ou de criptoativos em moeda
            fiduciária, o provedor terceirizado do serviço de Ramp poderá
            cobrar uma taxa entre R$ 0,10 e R$ 0,75 por depósito ou transação,
            conforme aplicável.
          </Typography.Label>

          <Typography.Label size="small" color="neutral.400">
            As taxas cobradas por terceiros poderão variar dentro dos
            intervalos descritos acima e serão determinadas e cobradas pelos
            respectivos prestadores de serviço. As taxas e respectivos
            valores poderão sofrer alterações a qualquer momento, de acordo
            com o provedor, a rota selecionada, as condições da transação ou
            outros fatores operacionais.
          </Typography.Label>
        </StyContent>
        <StyContent>
          <Typography.Label size="medium">Contato</Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            Dúvidas podem ser encaminhadas para
            <Typography.Label
              size="small"
              color="green.500"
              style={{ paddingLeft: `${SPACING._4}` }}
            >
              contact@cryptocontrol.pro
            </Typography.Label>
          </Typography.Label>
        </StyContent>
        <StyContent>
          <Typography.Label size="medium">Data de Vigência</Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            Estes Termos estão em vigor desde 01/01/2023 e podem ser atualizados
            sem aviso prévio.
          </Typography.Label>
        </StyContent>
      </StyContainer>
    </Modal>
  );
};
